import graphql__7da34930934955868f3d from "./__generated__/ContributionsDatavizThemesNavigation_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";
import { sum } from "lodash";

import { useFormatMessage } from "../../../Intl/Context";
import ContributionsDatavizThemesNavigationTheme from "./ContributionsDatavizThemesNavigationTheme";

const ContributionsDatavizThemesNavigation = props => {
  const participativeModule = useFragment(
    ContributionsDatavizThemesNavigation_participativeModule,
    props.participativeModule
  );
  const { graphViewActive, listViewActive, contributionDatavizRootTitleId } = props;
  const { themes } = participativeModule;
  const themesCount = themes.length;

  const subThemesCount = sum(
    participativeModule.themes.map(({ children }) => children.length)
  );
  const hasSubThemes = subThemesCount > 0;

  const t = useFormatMessage();
  const title = t(intlMessages.title, { count: themesCount });
  const subThemesLabel = t(intlMessages.subThemes, { count: subThemesCount });

  const className = classNames([
    "col-lg-4",
    "order-1",
    "order-lg-0",
    { "d-none d-lg-block": listViewActive }
  ]);

  return (
    <section className={className}>
      <div className="participative-datavisualization-theme-view-header participative-datavisualization-theme-view-header-sidebar box title text-greater d-flex align-items-center margin-bottom-xs padding-sm">
        <h2
          className="text-title-section d-flex align-items-center w-100"
          id={contributionDatavizRootTitleId}
        >
          <span className="d-block flex-1 text-center">
            <span className="text-primary margin-right-xxs">{themesCount}</span>
            {title}
          </span>

          {hasSubThemes && (
            <span className="d-block flex-1 text-center margin-left-xs padding-left-xs border-left">
              <span className="text-primary margin-right-xxs">{subThemesCount}</span>
              {subThemesLabel}
            </span>
          )}
        </h2>
      </div>

      <div className="box padding-sm">
        {themes.map((theme, index) => (
          <ContributionsDatavizThemesNavigationTheme
            key={theme.id}
            participativeModule={participativeModule}
            theme={theme}
            graphViewActive={graphViewActive}
            listViewActive={listViewActive}
            isLastTheme={index === themes.length - 1}
            displayAsOneLevel={!hasSubThemes}
          />
        ))}
      </div>
    </section>
  );
};

const ContributionsDatavizThemesNavigation_participativeModule = graphql__7da34930934955868f3d;

export default ContributionsDatavizThemesNavigation;

const intlMessages = defineMessages({
  title: {
    id: "contributions.dataviz.themes.title",
    defaultMessage: "{count, plural, one { thème } other { thèmes }}"
  },
  subThemes: {
    id: "contributions.dataviz.subThemes",
    defaultMessage: "{count, plural, one { sujet } other { sujets }}"
  }
});
